import React, { FC, useState } from "react";
import { ESRQuestion } from "./ESRQuestion";
import Grid from "@mui/material/Grid";
import { ESRQuestionSubgroupConfig, } from "../types/data";
import { Box, Collapse, Typography } from "@mui/material";
import { ExpandLessOutlined } from "@mui/icons-material";
import { ESRQuestionLabel } from "./ESRQuestionLabel";
import { splitQuestionsIntoRows, isFullWidth } from "../utils";
import {useParams} from "react-router-dom";

export const ESRQuestionSubGroup: FC<ESRQuestionSubgroupConfig> = (props) => {
	const { esrId = "", activeId = "" } = useParams();

	const [expanded, setExpanded] = useState(true);
	// This will be used to select the DOM node for scrolling
	const id = "subgroup-" + props.name.replace(/[^\w]/g, "-");
	const subgroupId = props.name.substring(0, 4);
	const needsDeclarationStatement = subgroupId.startsWith("3.6") || subgroupId.startsWith("4.2") || subgroupId.startsWith("5.1") || subgroupId.startsWith("6.1")
	return (
		<Box id={id} sx={{ my: "40px" }}>
			<Box
				role="button"
				tabIndex={0}
				aria-expanded={expanded}
				sx={{
					display: "flex",
					alignItems: "center",
					userSelect: "none",
					cursor: "pointer",
				}}
				onClick={() => setExpanded(!expanded)}
				onKeyDown={(e) => {
					if (e.key === "Enter" || e.key === " ") {
						e.preventDefault();
						setExpanded(!expanded);
					}
				}}
			>
				<ExpandLessOutlined
					sx={{
						color: "#003E628A",
						transition: "all 0.2s",
						transform: expanded ? "none" : "rotate(-180deg)",
					}}
				/>
				<Typography
					component="h3"
					sx={{
						fontSize: 20,
						fontWeight: 500,
						color: "#00000099",
					}}
				>
					{props.name}
				</Typography>
			</Box>
			<Collapse in={expanded}>
				{((activeId !== '' && esrId !== '') && activeId != esrId) ? (
					<>
						{needsDeclarationStatement &&
							<Box
								sx={{
									padding: "20px 52px",
									background: "#5a798b0a",
									borderRadius: "12px",
									mt: "12px",
								}}
							>
								{
									subgroupId.startsWith("3.6") &&
									<Typography variant="body2" color="error">
									These questions shall be answered for the entire project, not just the addendum area.  For example, If the project as a whole requires in stream work, but the addendum area does not require in stream work, then “Will this project require any in stream work” shall be marked as yes.  If this is a breakout project, the questions shall be answered for the breakout project only.
									</Typography>
								}
								{
									subgroupId.startsWith("4.2") &&
									<Typography variant="body2" color="error">
									These questions shall be answered for the entire project, not just the addendum area.  For example, if the project as a whole requires repair of highway signs, but the addendum area does not, then you shall mark yes to “Will the project involve repair or replacement of highway signs or other traffic control devices”.  If this is a breakout project, the questions shall be answered for the breakout project only.
									</Typography>
								}
								{
									subgroupId.startsWith("5.1") &&
									<Typography variant="body2" color="error">
									These questions shall be answered for the entire project, not just the addendum area.  For example, if the project as a whole requires tree removal, but the addendum area does not require tree removal, you shall mark yes to “Will this project require tree removal” and state the total tree removal required.  If this is a breakout project, the questions shall be answered for the breakout project only.
									</Typography>
								}
								{
									subgroupId.startsWith("6.1") &&
									<Typography variant="body2" color="error">
									These questions shall be answered for the entire project, not just the addendum area.  For example, if the project as a whole requires excavation on state owned ROW, but the addendum area does not require excavation on state owned ROW, you shall mark yes to “Will this project involve excavation on state owned ROW”.  If this is a breakout project, the questions shall be answered for the breakout project only.
									</Typography>
								}
							</Box>}
					</>
				) : null}
				<Box
					sx={{
						padding: "20px 52px",
						background: "#003E620A",
						borderRadius: "12px",
						mt: "12px",
					}}
				>
					<Grid container spacing="30px">
						{/*  TODO: Add a filter for questions that have a value */}
						{splitQuestionsIntoRows(props.questions, 3).flatMap(
							(questions, i) => [
								...questions.map((q, j) => (
									<Grid
										item
										key={q ? `label-${q.question_id}` : `label-${i}-${j}`}
										xs={q && isFullWidth(q) ? 12 : 4}
									>
										{q ? <ESRQuestionLabel {...q} /> : null}
									</Grid>
								)),
								...questions.map((q, j) => (
									<Grid
										item
										key={q ? `input-${q.question_id}` : `input-${i}-${j}`}
										xs={q && isFullWidth(q) ? 12 : 4}
									>
										{q ? <ESRQuestion {...q} /> : null}
									</Grid>
								)),
							],
						)}
					</Grid>
				</Box>
			</Collapse>
		</Box>
	);
};
